import { Box, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import DeleteAlert from "../../../components/Alerts/DeleteAlert";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import GlobalTable from "../../../components/Tables/GlobalTable";
import {
  deleteCompanyUser,
  getAllCompanyUser,
} from "../../../services/company/companyUsersApiFn";
import { handleOpenSnackBar } from "../../../utils";
import AddEditCompanyUserDialog from "./AddEditCompanyUserDialog";
import { t } from "i18next";

const headerData = [
  "userImage",
  "name",
  "userRole",
  "contact",
  "email",
  "actions",
];

const tableRows = [
  "showUserImage",
  "name",
  "showUserRole",
  "contact",
  "email",
  "actions",
];

function AllCompanyUsers() {
  const openDialog = useRef();
  const openDeleteDialog = useRef(null);
  const [allRole, setAllRole] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    fetchAllCompanyUsers();
  }, []);

  const fetchAllCompanyUsers = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyUser(userData?.adminId);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllRole(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditRole = (row, ind) => {
    openDialog.current.openDialog({
      type: "edit",
      data: row,
      getData: fetchAllCompanyUsers,
    });
  };

  const handleOpenDeleteDialog = (params) => {
    openDeleteDialog.current.openDialog({
      data: params.row,
      warningText: t("confirmDeleteRole"),
    });
  };

  const handleDelete = async (params) => {
    try {
      setIsLoading(true);
      const response = await deleteCompanyUser(params.data._id);
      if (response.data.status) {
        openDeleteDialog.current.closeDialog();
        fetchAllCompanyUsers();
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"createNewUser"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllCompanyUsers,
              })
            }
          />
        </Box>
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("createUsers")}
        secondaryHeading={t("userManagementDescription")}
        headProps={renderRightPart()}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allRole}
          showActions={true}
          showEdit={true}
          handleEdit={handleEditRole}
          showDelete={true}
          handleDelete={handleOpenDeleteDialog}
        />
      </AppContainer>
      <AddEditCompanyUserDialog ref={openDialog} />
      <DeleteAlert ref={openDeleteDialog} handleDelete={handleDelete} />
    </>
  );
}

export default AllCompanyUsers;
